import { j as t } from "../../../jsx-runtime.BREq8dyb.js";
import { Checkbox as n, Radio as i } from "@mui/joy";
import { memo as x } from "react";
const d = x(({
  selectable: m,
  color: r,
  variant: o,
  compact: e
}) => {
  const {
    component: a,
    ...s
  } = m;
  switch (a) {
    case "radio":
      return /* @__PURE__ */ t.jsx(
        i,
        {
          color: r === "neutral" ? "primary" : r,
          overlay: !0,
          size: e ? "sm" : "md",
          sx: {
            ml: "auto",
            zIndex: 2
          },
          variant: o,
          ...s
        }
      );
    case "checkbox":
      return /* @__PURE__ */ t.jsx(
        n,
        {
          color: r === "neutral" ? "primary" : r,
          overlay: !0,
          size: e ? "sm" : "md",
          sx: {
            ml: "auto",
            zIndex: 2
          },
          variant: o,
          ...s
        }
      );
  }
});
d.displayName = "DqCardControl";
export {
  d as default
};
//# sourceMappingURL=DqCardControl.js.map
